module.exports = __webpack_public_path__ + "static/studio_05-a0ea8f9ac684a0d7aa85d282d5fd556e.jpg";